import React, { ReactElement } from 'react';
import { Icons } from '@feast-it/ui/light';

import {
  StyledLink,
  StyledIcon,
  Content,
  SubtitleWrapper,
} from './PillButton.styled';

interface PillButtonProps {
  href: string;
  title: string;
  seoVertical: string;
  onClick?: () => void;
  icon?: string;
  inLocation?: string;
}

export function PillButton({
  icon,
  title,
  href,
  seoVertical,
  inLocation,
  onClick,
}: PillButtonProps): ReactElement {
  return (
    <StyledLink href={href} onClick={onClick}>
      {icon && (
        <StyledIcon name={icon as keyof Icons} size={35} fill="mediumBlue" />
      )}

      <Content>
        {title}

        <SubtitleWrapper>
          {seoVertical}

          {inLocation && <>&nbsp;{inLocation}&nbsp;</>}
        </SubtitleWrapper>
      </Content>
    </StyledLink>
  );
}
